
import AddRoleForm from '@/components/Management/User/AddRoleForm';

export default {
  components: {
    AddRoleForm
  }
};
